import { ScanMetadata } from '../../../../../interfaces/scanMetadata';
import { setRouteParams } from '../../../../../../shared/utils/angularUtils/setRouteParams/setRouteParams';
import { pathQueryParams } from '../../../../../../shared/constants/pathQueryParams';
import { getFormattedDate } from '../../../../../../shared/utils/dateUtils';
import {
  dateFormat,
  dateTimeFormat,
} from '../../../../../../shared/constants/apiDateFormat';

export const setDateRangeToParams = (
  scansMetadata: ScanMetadata[],
  startScanId: number | null,
  endScanId: number | null,
) => {
  if (!startScanId || !endScanId) {
    return;
  }

  const startScan = scansMetadata.find((scan) => scan.scanId === startScanId);
  const endScan = scansMetadata.find((scan) => scan.scanId === endScanId);

  const startDate = processScanDate(startScan);
  const endDate = processScanDate(endScan);

  setRouteParams({
    [pathQueryParams.startDate]: startDate,
    [pathQueryParams.endDate]: endDate,
  });
};

const processScanDate = (scan: ScanMetadata | undefined): string | null => {
  return scan?.scanDateTime
    ? getFormattedDate(scan.scanDateTime, dateFormat, dateTimeFormat)
    : null;
};
